import { render, staticRenderFns } from "./DispensationTab.vue?vue&type=template&id=1e621df2&scoped=true&"
import script from "./DispensationTab.vue?vue&type=script&lang=js&"
export * from "./DispensationTab.vue?vue&type=script&lang=js&"
import style0 from "./DispensationTab.vue?vue&type=style&index=0&id=1e621df2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e621df2",
  null
  
)

export default component.exports